import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import globalVar from './utilities/globalVar'
import ossImg from './directives/ossImg'


Vue.config.productionTip = false
Vue.prototype.GlobalData = globalVar

// 注册全局指令
Vue.directive('oss-img', ossImg)

export function createApp () {
    
    const app = new Vue({
        // el: '#app',
        router,
        store,
        render: h => h(App)
    })

    return { app, router, store }
}


